import { gql } from "@apollo/client";

// Shared GraphQL for the client's mid-job worker-request responses (time extension / extra
// helpers / materials + contest). Defined ONCE here and reused by both the /job-notifications
// route and the GLOBAL WorkerRequestModal so the respond/contest logic never diverges. These
// mirror the besthand-api mutations exactly (the worker app is the reference flow).
export const GET_PENDING_WORKER_REQUESTS = gql`
  query getPendingWorkerRequests($bookingId: Int) {
    getPendingWorkerRequests(bookingId: $bookingId) {
      status
      errorMessage
      results {
        id
        type
        bookingId
        title
        detail
        amount
        currency
        status
        expiresAt
      }
    }
  }
`;

export const RESPOND_TIME = gql`mutation($bookingId:Int!,$extensionId:Int!,$status:String!){respondTimeExtension(bookingId:$bookingId,extensionId:$extensionId,status:$status){status errorMessage}}`;
export const RESPOND_MATERIALS = gql`mutation($status:String,$bookingId:Int!){additionalFeeUserResponse(status:$status,bookingId:$bookingId){status errorMessage}}`;
export const RESPOND_WORKERS = gql`mutation($bookingId:Int!,$extraLaborId:Int!,$status:String!){respondExtraLabor(bookingId:$bookingId,extraLaborId:$extraLaborId,status:$status){status errorMessage}}`;
export const CONTEST = gql`mutation($bookingId:Int!,$requestId:Int!,$requestType:String,$reason:String,$proposedAmount:Float,$currency:String){contestWorkerRequest(bookingId:$bookingId,requestId:$requestId,requestType:$requestType,reason:$reason,proposedAmount:$proposedAmount,currency:$currency){status errorMessage contestId}}`;

// Accept / Decline a single request, picking the correct mutation by type. Identical mapping to
// the /job-notifications route. `mutators` is the object of bound useMutation tuples.
export async function respondToWorkerRequest({ r, accept, mutators }) {
  const status = accept ? "approved" : "rejected";
  if (r.type === "time") {
    await mutators.respondTime({ variables: { bookingId: r.bookingId, extensionId: r.id, status } });
  } else if (r.type === "materials") {
    await mutators.respondMaterials({ variables: { status, bookingId: r.bookingId } });
  } else if (r.type === "workers") {
    await mutators.respondWorkers({ variables: { bookingId: r.bookingId, extraLaborId: r.id, status } });
  }
}

// Contest / propose-a-fair-price flow (window.prompt based, SSR-safe). Returns false if the user
// cancelled the first prompt (so the caller can no-op).
export async function contestWorkerRequest({ r, mutators }) {
  if (typeof window === "undefined") return false;
  // eslint-disable-next-line no-alert
  const reason = window.prompt("Why are you contesting this? (optional)");
  if (reason === null) return false; // cancelled
  // eslint-disable-next-line no-alert
  const amtStr = window.prompt("Your proposed fair price (optional)");
  const proposedAmount = amtStr ? parseFloat(amtStr) : null;
  await mutators.contestReq({
    variables: {
      bookingId: r.bookingId,
      requestId: r.id,
      requestType: r.type,
      reason: reason || null,
      proposedAmount: Number.isFinite(proposedAmount) ? proposedAmount : null,
      currency: r.currency,
    },
  });
  return true;
}
